export default __webpack_public_path__ + "static/media/actividad-19.0351f064.mp3";